import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

import { UIActionModal, UITextarea } from "../../../../ui";

const EditRemovalReasonModal = ({
  open,
  applicants,
  copy,
  onClose,
  onSave,
}) => {
  const [reason, setReason] = useState("");
  const [reasonTouched, setReasonTouched] = useState(false);
  const isBulk = applicants.length > 1;
  const primaryApplicant = applicants[0];
  const trimmedReason = reason.trim();
  const showReasonError = reasonTouched && !trimmedReason;
  const message = isBulk
    ? copy.bulkMessage.replace("{count}", applicants.length)
    : copy.singleMessage;

  useEffect(() => {
    if (!open) return;
    setReason(
      !isBulk && primaryApplicant?.removalReason
        ? primaryApplicant.removalReason
        : "",
    );
    setReasonTouched(false);
  }, [isBulk, open, primaryApplicant]);

  const handleSave = () => {
    setReasonTouched(true);
    if (!trimmedReason) return;

    onSave({ reason: trimmedReason });
  };

  return (
    <UIActionModal
      open={open}
      onClose={onClose}
      title={copy.title}
      maxWidth="sm"
      PaperProps={{ className: "event-applicants-edit-removal-reason-modal" }}
      actions={
        <UIActionModal.Actions
          cancelLabel={copy.cancel}
          confirmLabel={copy.save}
          confirmDisabled={!trimmedReason}
          onCancel={onClose}
          onConfirm={handleSave}
        />
      }
    >
      {!isBulk && primaryApplicant ? (
        <UIActionModal.UserInfo
          name={primaryApplicant.name}
          image={primaryApplicant.image}
          description={`${copy.requestedRole}: ${primaryApplicant.requestedRole}`}
        />
      ) : (
        <Typography className="ui-action-modal__body-text">{message}</Typography>
      )}
      <UIActionModal.Divider />
      <UITextarea
        label={copy.reasonLabel}
        name="removalReason"
        value={reason}
        placeholder={copy.placeholder}
        onValueChange={(value) => {
          setReason(value);
          if (reasonTouched && value.trim()) {
            setReasonTouched(false);
          }
        }}
        onBlur={() => setReasonTouched(true)}
        required
        error={showReasonError}
        helperText={showReasonError ? copy.reasonRequired : null}
        minRows={3}
        classNames={{ root: "event-applicants-edit-removal-reason-modal__field" }}
      />
    </UIActionModal>
  );
};

EditRemovalReasonModal.propTypes = {
  open: PropTypes.bool.isRequired,
  applicants: PropTypes.arrayOf(PropTypes.object),
  copy: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

EditRemovalReasonModal.defaultProps = {
  applicants: [],
};

export default EditRemovalReasonModal;
